import * as ActionType from "../actionType";
import { fetchPromotionApi } from "../../services/page/promotion";

const getPromotionAction = () => {
  return async dispatch => {
    dispatchPromotion(dispatch);
  };
};

const dispatchPromotion = dispatch => {
  fetchPromotionApi().then(data => {
    dispatch({
      type: ActionType.RECEIVE_PROMOTION,
      data
    });
  });
};

export { getPromotionAction, dispatchPromotion };



// WEBPACK FOOTER //
// ./src/actions/page/promotion.js